import { Button } from 'components/buttons/Button/Button';
import './styles.scss';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';
import { ROUTES } from 'constants/routes';

const TrialResults = () => {
    const {
        discover_information_description,
        discover_information_title,
        discover_nutrition_background,
        discover_nutrition_description,
        discover_nutrition_title,
        discover_trial_description,
        discover_trial_image,
        discover_trial_title,
        discover_title,
    } = useSelector(state => state?.homepage?.data?.data) || {};

    return (
        <section className="container">
            <div className="trial-results">
                <GradientText size="middle" textColor="white">
                    <span dangerouslySetInnerHTML={{ __html: discover_title }} />
                </GradientText>
                <div className="trial-results__inner-container">
                    <div className="trial-results__content">
                        <div className="trial-results__up">
                            <img src={discover_trial_image} alt="charts" />
                        </div>
                        <div className="trial-results__down">
                            <h4>{discover_trial_title}</h4>
                            <p className="body1">{discover_trial_description}</p>
                            <Button href={ROUTES.trialResults} type="learn-more-arrow" />
                        </div>
                    </div>
                    <div
                        className="crop-nutrition"
                        style={{ backgroundImage: `url(${discover_nutrition_background})` }}
                    >
                        <div>
                            <h4>{discover_nutrition_title}</h4>
                            <p className="body1">{discover_nutrition_description}</p>
                            <Button href={ROUTES.cropNutritionPrograms} type="learn-more-arrow" />
                        </div>
                    </div>
                    <div className="information-materials">
                        <h4>{discover_information_title}</h4>
                        <p className="body1">{discover_information_description}</p>
                        <Button href={ROUTES.informationMaterials} type="learn-more-arrow" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrialResults;
